module.exports = __webpack_public_path__ + "img/galery-rku10-3.409c03a3.png";